import React, { useState } from 'react';
import ServiceCard from '../../components/ServiceCard/ServiceCard';
import './SuperApp.css';

// Import icons - commented out for now
// import foodIcon from '../../assets/icons/food.png';
// import supermartIcon from '../../assets/icons/supermart.png';
// import expressIcon from '../../assets/icons/express.png';
// import ridesIcon from '../../assets/icons/rides.png';
// import payIcon from '../../assets/icons/pay.png';
// import rewardsIcon from '../../assets/icons/rewards.png';

const SuperApp = () => {
  // State to track which user type is selected
  const [userType, setUserType] = useState('consumer');

  // Data for different user types
  const userTypeData = {
    consumer: {
      title: 'Deliveries',
      subtitle: 'enjoy the convenience of Delivery',
      services: [
        {
          icon: null,
          title: 'Food',
          description: 'Have all your cravings delivered to your doorstep.'
        },
        {
          icon: null,
          title: 'Supermart',
          description: 'Find everything you need—groceries and more.'
        },
        {
          icon: null,
          title: 'Express',
          description: 'Send packages, documents, and beyond.'
        },
        {
          icon: null,
          title: 'Rides',
          description: 'Select from a range of safe transportation choices, including shared and private options, to get you to your destination.'
        },
        {
          icon: null,
          title: 'Pay',
          description: 'Experience the future of payments: Simple, Smart & Secure.'
        },
        {
          icon: null,
          title: 'Rewards',
          description: 'Discover exciting rewards with every purchase - earn coins and unlock amazing experiences.'
        }
      ]
    },
    driver: {
      title: 'Earn with Switch',
      subtitle: 'unlock rewards with every switch',
      services: [
        {
          icon: null,
          title: 'Ride with us',
          description: 'Your Time. Your Rules.'
        },
        {
          icon: null,
          title: 'Deliver with us',
          description: 'Your City. Your Deliveries. Your Earnings.'
        }
      ]
    },
    merchant: {
      title: 'Grow your business',
      subtitle: 'grow beyond limits',
      services: [
        {
          icon: null,
          title: 'Sell with us',
          description: 'The Switch to wider Reach.'
        },
        {
          icon: null,
          title: 'Payments with us',
          description: 'SwitchPay: Your secure gateway to cashless transactions.'
        },
        {
          icon: null,
          title: 'Deliver with us',
          description: 'Big Orders. Small Packages. Seamless Solutions.'
        }
      ]
    },
    enterprise: {
      title: 'Enterprise Solutions',
      subtitle: 'scalable solutions for your business',
      services: [
        {
          icon: null,
          title: 'Corporate Mobility',
          description: 'Efficient transportation solutions for your team.'
        },
        {
          icon: null,
          title: 'Business Delivery',
          description: 'Fast, reliable logistics for your business operations.'
        },
        {
          icon: null,
          title: 'Enterprise API',
          description: 'Seamless integration with your existing systems.'
        }
      ]
    }
  };

  // Get current user type data
  const currentTypeData = userTypeData[userType];

  return (
    <div className="superapp">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1 className="title title-lg">Covering Your Essentials</h1>
          <h2 className="subtitle">Unlocking Your Potential</h2>
          <p className="description">Experience the All-in-One Platform.</p>
          
          <div className="user-types">
            <button 
              className={`button ${userType === 'consumer' ? 'active' : ''}`}
              onClick={() => setUserType('consumer')}
            >
              Consumer
            </button>
            <button 
              className={`button ${userType === 'driver' ? 'active' : ''}`}
              onClick={() => setUserType('driver')}
            >
              Driver
            </button>
            <button 
              className={`button ${userType === 'merchant' ? 'active' : ''}`}
              onClick={() => setUserType('merchant')}
            >
              Merchant
            </button>
            <button 
              className={`button ${userType === 'enterprise' ? 'active' : ''}`}
              onClick={() => setUserType('enterprise')}
            >
              Enterprise
            </button>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <div className="container">
          <div className="service-section">
            <h2 className="service-section__title">{currentTypeData.title}</h2>
            <p className="service-section__subtitle">{currentTypeData.subtitle}</p>
            <div className="service-cards">
              {currentTypeData.services.map((service, index) => (
                <ServiceCard key={index} {...service} />
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SuperApp; 